module.exports = __webpack_public_path__ + "static/img/wordpress.eec9fcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/wordpress.jpg
// module id = VwsU
// module chunks = 0